"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRemoteConfigEndpoint = exports.fetchRemoteConfig = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _request = _interopRequireDefault(require("../block-party/util/request"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var loginApiConfig = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(_ref) {
    var endpoint, _ref$method, method, payload, _ref$headers, headers, options;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpoint = _ref.endpoint, _ref$method = _ref.method, method = _ref$method === void 0 ? "GET" : _ref$method, payload = _ref.payload, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers;
            options = {
              method: method,
              body: JSON.stringify(payload),
              headers: _objectSpread(_objectSpread({}, headers), {}, {
                Accept: "application/json",
                "Content-Type": "application/json"
              })
            };
            _context.next = 4;
            return (0, _request.default)("".concat(endpoint), options);
          case 4:
            return _context.abrupt("return", _context.sent);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function loginApiConfig(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getRemoteConfigEndpoint = function getRemoteConfigEndpoint() {
  var FORNO_ENDPOINT = "https://cozy-assets.forno.quintoandar.com.br/bioma/auth/remoteConfig.json";
  var PROD_ENDPOINT = "https://cozy-assets.quintoandar.com.br/bioma/auth/remoteConfig.json";
  return window.location.origin.match("forno") ? FORNO_ENDPOINT : PROD_ENDPOINT;
};
exports.getRemoteConfigEndpoint = getRemoteConfigEndpoint;
var fetchRemoteConfig = function () {
  var _ref3 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
    var endpoint;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            endpoint = getRemoteConfigEndpoint();
            return _context2.abrupt("return", fetch(endpoint).then(function (res) {
              return res.json();
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchRemoteConfig() {
    return _ref3.apply(this, arguments);
  };
}();
exports.fetchRemoteConfig = fetchRemoteConfig;
var _default = loginApiConfig;
exports.default = _default;